"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStoreApiClient = createStoreApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function mapStoreApiToStoreDto(partnerId, store) {
    return {
        partnerId,
        acceptCropProtection: store.accept_crop_protection,
        acceptFertilizerBigbag: store.accept_fertilizer_bigbag,
        acceptFertilizerBulk: store.accept_fertilizer_bulk,
        acceptFertilizerOtherPackaging: store.accept_fertilizer_other_packaging,
        acceptFertilizerTank: store.accept_fertilizer_tank,
        acceptSeeds: store.accept_seeds,
        addressLine1: store.address_line1,
        addressLine2: store.address_line2,
        addressLine3: store.address_line3,
        city: store.city,
        code: store.code,
        contactPhone: store.contact_phone,
        gpsLocationLat: store.gps_location_lat,
        gpsLocationLong: store.gps_location_long,
        isClickAndCollect: store.is_click_and_collect,
        isDeparturePoint: store.is_departure_point,
        isPickupPoint: store.is_pickup_point,
        name: store.name,
        postalCode: store.postal_code,
        region: store.region,
        schedule: store.schedule,
        state: store.state,
        timezone: store.timezone
    };
}
function createStoreApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function findAllStoresByPatnerId(partnerId) {
        try {
            const response = await client.get(`/v1/cooperatives/${partnerId}/stores`);
            return response.data.map(mapStoreApiToStoreDto.bind(null, partnerId));
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        findAllStoresByCooperativeId: findAllStoresByPatnerId
    };
}
//# sourceMappingURL=data:application/json;base64,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